import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import { useNavigate, Link } from 'react-router-dom'
import React, { useState, useRef } from "react"
import axios from 'axios'
import DivBottom from '../userNotAuth/components/divBottom'

function Login() {
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        email: null,
        password: null,
        notAuthorized: null,
        emailConfirm: null,
        ricordami: true,
    })
    const [msg, setMsg] = useState({ email: false, password: false })
    const form = useRef()
    const recPassDom = useRef()
    const invioEmailDom = useRef()
    const password = useRef()

    function handleChange(e) {
        const { name, value, type, checked } = e.target
        let inputValue = type === "checkbox" ? checked : value
        setFormData({ ...formData, [name]: inputValue })
        setMsg({//gestisce controllo errori credenziali di accesso
            email: false,
            password: false,
            notAuthorized: false,
            emailConfirm: false
        })
        if (name === 'mostraPassword') {
            inputValue ? password.current.type = 'text' :
                password.current.type = 'password'
        }
    }
    function handleLogin(e) {
        e.preventDefault()
        const validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!validRegex.test(formData.email) || formData.email === '') {
            setMsg({ email: true }); return
        }
        if (formData.password.length < 8) { setMsg({ password: true }); return }
        try {
            axios.post('/login', formData).then(
                res => {
                    if (res.data.message === 'credenziali corrette') {
                        localStorage.setItem('logged', true)//gestisce comparsa link 'logout' in navbar
                        localStorage.setItem('email', res.data.email)//gestisce comparsa link 'logout' in navbar
                        localStorage.setItem('nome', res.data.results[0].nome)
                        if (res.data.results[0].img) localStorage.setItem('img', res.data.results[0].img)
                        localStorage.setItem('id', res.data.results[0].id)
                        localStorage.setItem('disabledChat', res.data.results[0].disabledChat)
                        if (res.data.email === 'maladmin@admin.it') {
                            navigate('/homeAdmin', { replace: true })
                        } else
                            navigate('/', { replace: true })
                    }
                    else
                        if (res.data.message === 'email da confermare') {
                            setMsg({ emailNotConfirm: true })
                        } else setMsg({ notAuthorized: true })
                }
            )
        } catch (err) { console.error(err) }
    }
    function recuperoPassword(e) {
        const validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!validRegex.test(formData.emailConfirm) || formData.emailConfirm === '') {
            setMsg({ emailConfirm: 'Email non valida' }); return
        }
        axios.get(`/ceckEmailExist/${formData.emailConfirm}`).then(res => {
            if (res.data === 'email inesistente') {
                setMsg({ emailConfirm: 'Email non registrata' })
            } else if (res.data.message === 'email esistente') {
                localStorage.setItem('previousPage', '/login')
                navigate('/reimpostaPassword', {
                    replace: true, state: {
                        rndCode: res.data.rndCode,
                        email: formData.emailConfirm
                    }
                })
            }
        })
    }
    return (<>
        <NavbarNotAuth />
        <div className='container' style={{ marginTop: '7rem', marginBottom: '2rem' }} ref={form}>
            <h2>Login</h2>
            <div className="mt-4">
                <form onSubmit={handleLogin}>
                    <div className="error" style={{ backgroundColor: 'red' }}></div>
                    <div className="col-md-6">
                        <label htmlFor="email">Email:</label>
                        <input
                            className="form-control"
                            name="email" required
                            onChange={handleChange}
                            type="text"
                        />
                        {msg.email && <div style={{ color: 'red' }}>Email non valida</div>}
                        {msg.emailNotConfirm &&
                            <div style={{ color: 'red' }}>Email da confermare. Se non riesci ad accedere
                                effettua una nuova registrazione.
                            </div>}<br />
                        <label htmlFor="password">Password:</label>
                        <input ref={password}
                            type="password"
                            className="form-control"
                            name="password" required
                            onChange={handleChange}
                        />
                        {msg.password && <div style={{ color: 'red' }}>Min 8 caratteri</div>}
                        {msg.notAuthorized && <div style={{ color: 'red' }}>Email o password sbagliate</div>}
                        <div className='mt-3'>
                            <label htmlFor="ricordami">Rimani connesso</label>
                            <input style={{ marginLeft: '1rem' }}
                                checked={formData.ricordami}
                                type='checkbox'
                                name='ricordami'
                                onChange={handleChange}
                            />
                            <label htmlFor='mostraPassword' style={{ marginLeft: '2rem' }}>
                                Mostra Password
                            </label>
                            <input type='checkbox' style={{ marginLeft: '1rem' }}
                                name='mostraPassword'
                                onChange={handleChange}>
                            </input>
                        </div>
                        <button className='btn btn-primary mt-3' type="submit">Accedi</button>
                    </div>
                </form>
                <p className="p-1 mt-3" style={{
                    backgroundColor: 'lightcyan',
                    width: 'fit-content',
                    cursor: 'pointer'
                }} onClick={() => { recPassDom.current.style.display = 'block' }}>
                    Password dimenticata ? Cambia password.
                </p>

                <div ref={recPassDom} style={{
                    display: 'none',
                    border: '1px solid royalblue',
                    padding: '1rem',
                    cursor: 'pointer'
                }}>
                    <p className='float-end fs-2' onClick={() => {
                        recPassDom.current.style.display = "none"
                        setMsg({ emailConfirm: false })
                    }}>X</p>
                    <label>Inserisci l'email:</label>
                    <input
                        className="form-control"
                        name="emailConfirm"
                        onChange={handleChange}
                        type="text"
                    />
                    {msg.emailConfirm && <div style={{ color: 'red' }}>{msg.emailConfirm}</div>}
                    <button className='btn btn-secondary mt-3' onClick={recuperoPassword}>
                        Recupera password
                    </button>
                </div>
            </div>

            {/* <p style={{ cursor: 'pointer', marginTop: '2em' }}>
                NON SEI REGISTRATO?
                <Link to={{ pathname: '/register' }}>
                    <u> clicca qui </u>
                </Link> e registrati
            </p> */}

        </div>

        <div style={{ marginTop: '26px' }}>
            <DivBottom />
        </div>

        <div ref={invioEmailDom} style={{
            position: 'fixed',
            top: '-50rem',
            height: '100%',
            width: '100%',
            transition: '.2s',
            border: '1px solid grey',
            backgroundColor: 'mintcream',
            padding: '150px 15px',
            fontSize: 'x-large'
        }}>
            Abbiamo inviato un'email al tuo indirizzo di posta elettronica
            <i style={{ color: 'steelblue' }}> {formData.emailConfirm} </i>
            con la quale potrai procedere al recupero delle password.
            <div className='mt-4'>
                <button className='btn btn-primary' onClick={() => {
                    invioEmailDom.current.style.top = '-50rem'
                    form.current.style.display = 'block'
                    recPassDom.current.style.display = 'none'
                }}>
                    Login
                </button>
            </div>
        </div>
    </>
    )
}

export default Login